<template>
  <div class="s-canvas">
    <canvas id="s-canvas" :width="contentWidth" :height="contentHeight"></canvas>
  </div>
</template>
<script>
export default {
  name: "SIdentify",
  props: {
    identifyCode: {     //預設驗證碼
      type: String,
      default: "1234",
    },
    fontSizeMin: {      //最小字體
      type: Number,
      default: 35,
    },
    fontSizeMax: {      //最大字體
      type: Number,
      default: 35,
    },
    backgroundColorMin: {   //背景顏色最小值
      type: Number,
      default: 180,
    },
    backgroundColorMax: {   //背景顏色最大值
      type: Number,
      default: 255,
    },
    colorMin: {         //字體顏色最小值
      type: Number,
      default: 0,
    },
    colorMax: {         //字體顏色最大值
      type: Number,
      default: 50,
    },
    lineColorMin: {     //干擾線顏色最小值
      type: Number,
      default: 50,
    },
    lineColorMax: {     //干擾線顏色最大值
      type: Number,
      default: 255,
    },
    dotColorMin: {      //干擾顏色最小值
      type: Number,
      default: 50,
    },
    dotColorMax: {      //干擾顏色最大值
      type: Number,
      default: 255,
    },
    contentWidth: {     //寬
      type: Number,
      default: 175,
    },
    contentHeight: {    //高
      type: Number,
      default: 35,
    },
  },
  methods: {
    // 隨機產數
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 隨機顏色
    randomColor(min, max) {
      let r = this.randomNum(min, max);
      let g = this.randomNum(min, max);
      let b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    drawPic() {
      let canvas = document.getElementById("s-canvas");
      let ctx = canvas.getContext("2d");
      ctx.textBaseline = "bottom";
      // 背景
      ctx.fillStyle = this.randomColor(
        this.backgroundColorMin,
        this.backgroundColorMax
      );
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
      // 文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    },
    drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
      ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px SimHei";
      let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
      let y = this.randomNum(this.fontSizeMax, this.contentHeight - 1);
      // 字體旋轉角度
      var deg = this.randomNum(-20, 20);
      // 修改座標原點和旋轉角度
      ctx.translate(x, y);
      ctx.rotate((deg * Math.PI) / 0);
      ctx.fillText(txt, 0, 0);
      // 恢復座標原點和旋轉角度
      ctx.rotate((-deg * Math.PI) / 0);
      ctx.translate(-x, -y);
    },
    drawLine(ctx) {
      // 繪製干擾線
      for (let i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(
          this.lineColorMin,
          this.lineColorMax
        );
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }
    },
    drawDot(ctx) {
      // 繪製干擾點
      for (let i = 0; i < 100; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          1,
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
  },
  watch: {
    identifyCode() {
      this.drawPic();
    },
  },
  mounted() {
    this.drawPic();
  },
};
</script>